<template>
  <funnel-step-layout anchor="locations">
    <div class="mb-4">{{$t(`step3.${entity}.title`)}}</div>
    <div class="container">
      <div class="row">
        <div class="d-none d-sm-block col-md-6 order-sm-2 mt-sm-4 mt-md-0 order-md-1">
          <px-map :countries="selectedCountries" :cities="selectedCities"></px-map>
        </div>
        <div class="col-md-6 col-xs-12 order-sm-1 order-md-2">
          <multiselect
          class="mb-3"
          v-if="entity !== ENTITIES.LOCALBUSINESS"
          :value="selectedCountries"
          @search-change="fetchCountries"
          @input="updateCountryLocations"
          track-by="id"
          :label="`name_${mapLang}`"
          :options="countries"
          :multiple="true"
          :close-on-select="false"
          :hide-selected="true"
          :selectLabel="$t('step3.placeholder_select_label')"
          :selectedLabel="$t('step3.placeholder_selected')"
          :deselectLabel="$t('step3.placeholder_deselect')"
          :limitText="count => `+ ${count}`"
          :placeholder="$t('step3.placeholder_select_country')">
          <span slot="noResult">{{$t('step3.placeholder_noResults_country')}}</span>
          </multiselect>
          <multiselect
          class="mb-4"
          :value="selectedCities"
          @search-change="fetchCities"
          @open="fetchCities('')"
          @input="updateCityLocations"
          track-by="id"
          :hide-selected="entity !== ENTITIES.LOCALBUSINESS"
          :label="`name_${mapLang}`"
          :options="cities"
          :multiple="entity !== ENTITIES.LOCALBUSINESS"
          :close-on-select="entity === ENTITIES.LOCALBUSINESS"
          :placeholder="$t('step3.placeholder_select_city')">
          <span slot="noResult">{{$t('step3.placeholder_noResults_city')}}</span>
          </multiselect>
          <px-button class="d-none d-md-block" :disabled="!canGoNext" @click="goNextStep" :text="$t('step3.cta')"></px-button>
          <div class="d-flex d-md-none align-items-center justify-content-center">
            <px-button class="d-block d-md-none" :disabled="!canGoNext" @click="goNextStep('next')" :text="$t('step3.cta')"></px-button>
          </div>
        </div>
      </div>
    </div>
  </funnel-step-layout>
</template>

<script>
import { mapGetters, mapState, mapActions } from 'vuex'
import Multiselect from 'vue-multiselect'
import { FunnelStepLayout } from '@/components/Layouts'
import { PxMap } from '@/components/UIComponents'
import { ENTITIES } from '@/settings'

export default {
  name: 'step-location-option',
  data () {
    return {
      ENTITIES
    }
  },
  components: {
    FunnelStepLayout,
    Multiselect,
    PxMap
  },
  methods: {
    ...mapActions('form', ['updateCityLocations', 'updateCountryLocations']),
    goNextStep (move) {
      if (this.canGoNext) {
        if (this.selectedCities.length === 0) {
          this.$notify({
            title: `${this.$t('step3.message_selection_all_cities_in_country')} ${this.namesOfCountries()}`,
            horizontalAlign: 'center',
            verticalAlign: 'bottom',
            type: 'success'
          })
        }
        this.$store.dispatch('form/goDurations')
        if (move === 'next') {
          this.$onePage.moveNext()
        }
      }
    },
    namesOfCountries () {
      return this.selectedCountries.map(country => country[`name_${this.mapLang}`]).join(', ')
    },
    fetchCities (query) {
      if (query.length || (this.entity !== ENTITIES.LOCALBUSINESS && this.selectedCountries.length)) {
        this.$store.dispatch('pxdata/searchCities', { lang: this.mapLang, query, filters: this.entity !== ENTITIES.LOCALBUSINESS ? this.selectedCountries.map(c => c.id) : undefined })
      }
    },
    fetchCountries (query) {
      if (query.length) {
        this.$store.dispatch('pxdata/searchCountries', { query, lang: this.mapLang })
      }
    }
  },
  computed: {
    ...mapGetters({
      entity: 'form/entity',
      nextIsDisplayed: 'form/can_display_durations',
      lang: 'lang',
      mapLang: 'mapLang'
    }),
    ...mapState('pxdata', {
      cities: state => state.all.cities,
      countries: state => state.all.countries
    }),
    ...mapState('form', {
      selectedCities: state => state.options.locations.cities,
      selectedCountries: state => state.options.locations.countries
    }),
    canGoNext () {
      return this.selectedCities.length || this.selectedCountries.length
    }
  },
  mounted () {
    window.$('.multiselect__content-wrapper').bind('mousewheel DOMMouseScroll', function (e) {
      e.stopPropagation()
    })
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
